import React, { createContext, useState, useContext } from 'react';

// Create Context
export const WizardContext = createContext();

// Create Provider
export const WizardProvider = ({ children }) => {
  // State variables from Step1.js
  const [selectionOption, setSelectionOption] = useState("15th_celebration");

  // State variables from Step2.js
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastname] = useState(null);
  const [chinesename, setChinesename] = useState(null);
  const [gender, setGender] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [do3R5P, setDo3R5P] = useState(true);
  const [doLunch, setDoLunch] = useState(false);
  const [englishXlation, setEnglishXlation] = useState(false);
  const [cantoneseXlation, setCantoneseXlation] = useState(false);
  const [needShuttleBus, setNeedShuttleBus] = useState(false);
  const [isVolunteering, setIsVolunteering] = useState(false);

  const [s8_9_9_30, setS8_9_9_30] = React.useState(false);
  const [s8_9_13_30, setS8_9_13_30] = React.useState(false);
  const [s15_9_9_30, setS15_9_9_30] = React.useState(false);
  const [s22_9_9_30, setS22_9_9_30] = React.useState(false);
  const [s29_9_9_30, setS29_9_9_30] = React.useState(false);
  const [s6_10_9_30, setS6_10_9_30] = React.useState(false);
  const [s13_10_9_30, setS13_10_9_30] = React.useState(false);
  const [s20_10_9_30, setS20_10_9_30] = React.useState(true);
  const [s27_10_9_30, setS27_10_9_30] = React.useState(true);
  const [s27_10_13_30, setS27_10_13_30] = React.useState(true);

  // State variables from Step3.js
  // Define them similarly...
  // Example:
  const [confirmation, setConfirmation] = useState(false);

  // Functions to validate or manage the steps, if needed, can be defined here too.
  const isValidatedStep1 = () => {
    return selectionOption !== null;
  };

  const isValidatedStep2 = () => {
    // Add your validation logic for Step2 here
    return true;
  };

  const isValidatedStep3 = () => {
    // Add your validation logic for Step3 here
    return true;
  };

  // Export all state variables and setters
  return (
    <WizardContext.Provider
      value={{
        selectionOption, setSelectionOption,
        firstname, setFirstname,
        lastname, setLastname,
        chinesename, setChinesename,
        gender, setGender,
        email, setEmail,
        phone, setPhone,
        do3R5P, setDo3R5P,
        doLunch, setDoLunch,
        confirmation, setConfirmation,
        englishXlation, setEnglishXlation,
        cantoneseXlation, setCantoneseXlation,
        needShuttleBus, setNeedShuttleBus,
        isVolunteering, setIsVolunteering,
        s8_9_9_30, setS8_9_9_30,
        s8_9_13_30, setS8_9_13_30,
        s15_9_9_30, setS15_9_9_30,
        s22_9_9_30, setS22_9_9_30,
        s29_9_9_30, setS29_9_9_30,
        s6_10_9_30, setS6_10_9_30,
        s13_10_9_30, setS13_10_9_30,
        s20_10_9_30, setS20_10_9_30,
        s27_10_9_30, setS27_10_9_30,
        s27_10_13_30, setS27_10_13_30
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

// Custom hook for using the Wizard Context
export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};
